import * as React from 'react';

const Mail = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#223260"
            fillRule="evenodd"
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m6 9.867-5.688 3.678-.086.045a.58.58 0 0 1-.465-.005l-.073-.04L6 9.867V14.8A1.2 1.2 0 0 0 7.2 16h9.6a1.2 1.2 0 0 0 1.2-1.2zM16.8 8H7.2a1.2 1.2 0 0 0-1.064.644L12 12.434l5.864-3.79A1.2 1.2 0 0 0 16.8 8"
            clipRule="evenodd"
        />
    </svg>
);
export default Mail;
